import { ref } from 'vue';

// Module-level: ShiftView writes, AppShell reads — no polling, no DB calls in shell
export const activeSession = ref<{ clockIn: string; entryType: string; workplace: string } | null>(
  null,
);
